import Button from "@ui-components/Button";
import { ModalOpenerButtonProps} from "./Resales.type";

export const ModalOpenerButton = ({
  value,
  stateSetterFn,
}:ModalOpenerButtonProps) => {
  return <Button
    styleType="empty"
    className="text-xs h-7"
    onClick={(e:any) => {
      stateSetterFn(value)
      e.stopPropagation()
    }}
  >
    {value.length}
  </Button>
}
